import Link from 'next/link';
import { useRouter } from 'next/router';
import { branch } from '../../../Constants/branchUrls';
import { removeDefaultParams } from '../../../Utils/helper';
import { ToolContainer, ToolImage, ToolName, ToolWrapper } from './styled';
import { fireEvent } from '../../../Utils/fireEvent';

export default function Tools(props) {
  const { data } = props;
  let router = useRouter();
  // const toolClick = (value) => {
  //     redirectToExternalSite(value);
  // };
  const redirection = (element) => {
    if (element.id != 8 && element.id != 52) {
      fireEvent({
        category: 'clicked_download_app',
        screen_name: 'Other',
        name: 'google_play',
        deeplink_value: branch.reqF5mGP1lb,
        page_url: window?.location?.href,
      });
    }
  };
  const item = [];
  data.forEach((element, index) => {
    if (
      element.value &&
      (element.type == 1 ||
        element.id == 52 ||
        element?.id == 54 ||
        element?.id == 8)
    ) {
      item.push(
        <Link
          href={{
            pathname: element?.value,
            query: removeDefaultParams(router.query),
          }}
          passHref
          locale={false}
          target="_blank"
        >
          <ToolWrapper
            onClick={() => {
              redirection(element);
            }}
            key={index}
          >
            <ToolImage
              src={element?.image}
              loading="lazy"
              alt={element?.name}
            />
            <ToolName>{element?.name}</ToolName>
          </ToolWrapper>
        </Link>,
      );
    }
  });
  return (
    <>
      <ToolContainer>{item}</ToolContainer>
    </>
  );
}
